import {queryOptions, type UseQueryOptions} from '@tanstack/react-query';
import {USER_QUERY_KEY_MAP} from '../api/user/constant';
import {postGatewayUserGetAgeAuth} from '../api/user/postGatewayUserGetAgeAuth';
import type {FetcherOptions} from '../axios/axiosBffFetch';
import {PagewebError} from '../errors/PagewebError.class';
import {createAgeAuth} from '../graphql/factory/AgeAuth';
import {
  type AgeAuthQuery,
  type AgeAuthQueryVariables,
  ResultStatus,
} from '../graphql/generated/types';

/**
 * User 도메인 Query Factory
 *
 * Adapter layer를 제거하고 Factory에서 직접 데이터 변환을 수행
 */
export const userFactory = {
  /**
   * 연령 인증 정보 조회
   *
   * ⚠️ 서버 사이드 로직 제외됨:
   * - 원본 Resolver에는 JWT 업데이트 및 쿠키 설정(roastAuthCookieSet) 로직 존재
   * - 클라이언트 환경에서는 구현 불가능하므로 순수 API 호출 + Factory 변환만 포함
   * - JWT 동기화가 필요한 경우, BFF에서 처리하거나 별도 방법 고려 필요
   */
  ageAuth: (
    variables: AgeAuthQueryVariables,
    options?: Omit<
      UseQueryOptions<AgeAuthQuery, PagewebError, AgeAuthQuery>,
      'queryKey' | 'queryFn'
    >,
    fetcherOptions?: FetcherOptions
  ) =>
    queryOptions({
      queryKey: USER_QUERY_KEY_MAP.ageAuth(variables),
      queryFn: async (): Promise<AgeAuthQuery> => {
        const data = await postGatewayUserGetAgeAuth(
          variables.ageLimit,
          fetcherOptions
        );
        return {
          ageAuth: {
            status: ResultStatus.Success,
            ...createAgeAuth(data),
          },
        };
      },
      ...options,
    }),
} as const;
